function Link01({
  color = 'currentColor',
  w = 20,
  h = 20,
  strokeWidth = 0.670909
}: {
  color?: string
  w?: number
  h?: number
  strokeWidth?: number
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={w} height={h} viewBox="0 0 21 20" fill="none">
      <path d="M11.0898 15.3032L9.91128 16.4817C8.2841 18.1089 5.64591 18.1089 4.01873 16.4817C2.39154 14.8546 2.39154 12.2164 4.01873 10.5892L5.19724 9.41068M15.8038 10.5892L16.9824 9.41067C18.6095 7.78349 18.6095 5.1453 16.9824 3.51812C15.3552 1.89093 12.717 1.89093 11.0898 3.51812L9.91128 4.69663M7.58387 12.9166L13.4172 7.08325" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default Link01
